export default "__VITE_ASSET__BYIX8gOC__"